import moment from 'moment-timezone';

function getDateOffset(
  dayOffset = 0,
  monthOffset = 0,
  yearOffset = 0,
  baseDate: string | number | Date = 0
): Date {
  const date = baseDate === 0 ? new Date() : new Date(baseDate);
  date.setHours(0, 0, 0, 0);
  const m = moment(date);
  if (dayOffset !== 0) m.add(dayOffset, 'day');
  if (monthOffset !== 0) m.add(monthOffset, 'month');
  if (yearOffset !== 0) m.add(yearOffset, 'year');
  return m.toDate();
}

function format(
  date: Date | string | undefined,
  pattern = 'YYYY-MM-DD'
): string {
  return moment(date).format(pattern);
}

function getMonthDiff(date1: Date, date2?: Date): number {
  if (!date2) date2 = getToday();
  return moment(date1).diff(moment(date2), 'months', false);
}

function getDiff(date1: Date, date2?: Date): number {
  if (!date2) date2 = getToday();
  return moment(date1).diff(moment(date2), 'days', false);
}

function isBetween(date: Date, startDate: Date, endDate: Date): boolean {
  const d = date.getTime();
  const s = startDate.getTime();
  const e = endDate.getTime();
  return d > s && d < e;
}

function isEqual(date1: Date, date2: Date): boolean {
  const equal = date1.getTime() === date2.getTime();
  return equal;
}

function isBefore(date1: Date, date2: Date): boolean {
  return date1.getTime() < date2.getTime();
}

function isBeforeOrEqual(date1: Date, date2: Date): boolean {
  return date1.getTime() <= date2.getTime();
}

function getDateString(
  date: Date | undefined,
  locale = 'en',
  size: 'lg' | 'md' | 'sm' = 'md'
) {
  if (!date) return '-';

  if (locale === 'pt-BR') {
    const day: string = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
    }).format(date);
    const month: string = new Intl.DateTimeFormat(locale, {
      month: 'short',
    })
      .format(date)
      .replace('.', '');
    const year: string = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
    }).format(date);
    return `${day} ${month} ${year}`;
  }

  const formatOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: size === 'sm' ? undefined : 'numeric',
  };

  return Intl.DateTimeFormat(locale, formatOptions).format(date);
}

function getToday(): Date {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date;
}

const TimeUtils = {
  getDateOffset,
  format,
  getMonthDiff,
  getDiff,
  isBefore,
  isBetween,
  isEqual,
  isBeforeOrEqual,
  getDateString,
  getToday,
};

export default TimeUtils;
